import { useParams, useSearchParams } from "react-router-dom";

import { FromPageProvider } from "../../providers/FromPageProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { SeatMapWrapper } from "../../components";

export default function SeatMapPage() {
  const { uuid, id } = useParams();

  const [searchParams] = useSearchParams();

  return (
    <FromPageProvider>
      <ModalProvider>
        <SeatMapWrapper
          eventId={uuid}
          groupTicketsId={id}
          offerId={searchParams.get("id")}
          assignTicketType={searchParams.get("type")}
        />
      </ModalProvider>
    </FromPageProvider>
  );
}
